import React from 'react';
import MasterDataBaseComponent from '../masterData/MasterDataBaseComponent';
import mdmActivityLogs from '../masterData/schemas/mdmActivityLogs';
import MdmBaseComponent from '../masterData/MdmBaseComponent';

const EmptyTabs = () => null;

const MdmActivityLogs = () => {
  // Provide only the mdm-activity-logs schema so the page focuses on logs
  const schema = mdmActivityLogs;
  return <MdmBaseComponent schema={schema} TabsComponent={EmptyTabs} />;
};

export default MdmActivityLogs;
